import styled from "styled-components";

export const StyledWhitelistedAddressesList = styled.div`
  width: 100%;

  .whitelistedAddresses {
    width: 100%;
  }
`;
